import { React, useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Space, Pagination } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Spin, Select } from 'antd';
import { debounce } from 'lodash';
import {
    create_play_history_actionHandler,
    create_play_view_history_actionHandler,
    setChatDocument,
} from '../../Redux/Actions/user/CreatePlayHistory';
import './PlayTabs.css';
let { Option } = Select;

function History({ setKey, key }) {
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [sortBy, setSortBy] = useState('');
    useEffect(() => {
        const delayedSearch = debounce(() => {
            dispatch(
                create_play_history_actionHandler(page, searchText, sortBy)
            );
        }, 800);

        delayedSearch();

        return delayedSearch.cancel;
    }, [dispatch, page, searchText, sortBy]);
    const getHistoryData =
        useSelector(
            (state) =>
                state.create_play_history_data?.create_play_history_data?.data
        ) || [];

    const loader = useSelector(
        (state) => state.create_play_history_data.loader
    );

    const { data, total, per_page, current_page } = getHistoryData;
    const viewHistoryData = (item) => {
        dispatch(create_play_view_history_actionHandler(item.id));

        if (item.is_chat_with_document == true) {
            dispatch(setChatDocument(true));
            setKey('2');
        } else {
            dispatch(setChatDocument(false));
            setKey('1');
        }
    };
    const paginate = (newPage) => {
        dispatch(create_play_history_actionHandler(newPage, searchText));
    };
    const handleSort = (field) => {
        dispatch(create_play_history_actionHandler(page, searchText, field));
    };
    // const filteredData = data?.filter((item) =>
    //   item.title?.toLowerCase().includes(searchText.toLowerCase())
    // );

    return (
        <div>
            <div className='search-sort mb-4'>
                <div className='search-container '>
                    <input
                        type='text'
                        value={searchText}
                        onChange={(e) => {
                            setSearchText(e.target.value);
                            setPage(1);
                        }}
                        className='search-input'
                        placeholder='Search'
                    />
                    <div className='search-icon'>
                        <svg
                            className='search-icon'
                            xmlns='http://www.w3.org/2000/svg'
                            width='16'
                            height='16'
                            viewBox='0 0 16 16'
                            fill='none'>
                            <path
                                d='M14.8856 14.6666L13.5427 13.3333M7.8356 13.9999C8.67324 13.9999 9.50269 13.8361 10.2766 13.5178C11.0505 13.1995 11.7536 12.733 12.3459 12.1449C12.9382 11.5568 13.4081 10.8586 13.7286 10.0902C14.0492 9.32185 14.2142 8.49829 14.2142 7.66659C14.2142 6.83488 14.0492 6.01132 13.7286 5.24292C13.4081 4.47453 12.9382 3.77635 12.3459 3.18824C11.7536 2.60014 11.0505 2.13363 10.2766 1.81535C9.50269 1.49707 8.67324 1.33325 7.8356 1.33325C6.1439 1.33325 4.52148 2.00051 3.32527 3.18824C2.12906 4.37597 1.45703 5.98688 1.45703 7.66659C1.45703 9.34629 2.12906 10.9572 3.32527 12.1449C4.52148 13.3327 6.1439 13.9999 7.8356 13.9999Z'
                                stroke='black'
                                stroke-width='1.5'
                                stroke-linecap='round'
                                stroke-linejoin='round'
                            />
                        </svg>
                    </div>
                </div>
                <div className=''>
                    <Select defaultValue='Sort by' onChange={handleSort}>
                        <Option value='output_name'>Sort by Output Name</Option>
                        <Option value='date'>Sort by Date</Option>
                    </Select>
                </div>
            </div>

            <div className='table-responsive history-table-wrapper'>
                {!loader && data?.length === 0 ? (
                    <div>No Matching Records Found</div>
                ) : (
                    <table className='table history-table w-100 table-striped table-borderless'>
                        <thead>
                            <th>Output Name</th>
                            <th>Output</th>
                            <th>Reference Data Selected</th>
                            <th>Date</th>
                            <th></th>
                        </thead>
                        <tbody>
                            {data?.map((item) => (
                                <tr key={item.id}>
                                    <td>{item.title || ''}</td>
                                    <td className='truncate'>{item.output}</td>
                                    <td>
                                        {item.documents?.length > 0
                                            ? item?.documents[0].name
                                            : ''}
                                    </td>
                                    <td>{item.date}</td>
                                    <td>
                                        <Link>
                                            <img
                                                onClick={() =>
                                                    viewHistoryData(item)
                                                }
                                                src='images/view-icon.svg'
                                                alt='View'
                                            />
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                {loader && (
                    <div className='spinner'>
                        <Spin />
                    </div>
                )}
                <div className='pagi-div'>
                    {total > 1 && (
                        <Pagination
                            defaultCurrent={1}
                            current={current_page}
                            total={total}
                            pageSize={10}
                            onChange={paginate}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
export default History;
